export default "__VITE_ASSET__pte3vN5E__"